import { ValidationErrors } from "@compass/core";
import { Permission, StaffService, StaffServiceEditResource, StaffServiceViewResource } from "generated/openApi";
import { StaffServicePageBody } from "pages/staff/staff-services/StaffServicePage/StaffServicePageBody/StaffServicePageBody";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ServiceInfo = (props: {
  service: StaffService;
  setService: (value: StaffService) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const [viewResource, setViewResource] = useState<StaffServiceViewResource>({} as StaffServiceViewResource);
  const [editResource, setEditResource] = useState<StaffServiceEditResource>({} as StaffServiceEditResource);

  useEffect(() => {
    fetchViewResource();
    fetchEditResource();
  }, []);

  const fetchViewResource = () => {
    ApiService.staffServices.getViewResource().then((response) => {
      setViewResource(response);
    });
  };

  const fetchEditResource = () => {
    ApiService.staffServices.getEditResource().then((response) => {
      setEditResource(response);
    });
  };

  return (
    <StaffServicePageBody
      rootPermission={Permission.StaffService}
      service={props.service}
      setService={props.setService}
      crudMode={"edit"}
      viewResource={viewResource}
      editResource={editResource}
      validationErrors={props.validationErrors}
      hideStaff
    />
  );
};
